import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from '@core/forms/form';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import { AddB2BInvoiceRequest } from '@api/models/B2bService/Contract/Invoice/add-b-2-b-invoice-request';


export enum InvoiceFormField {
    Date = 'date',
}

export interface InvoiceFormModel {
    [InvoiceFormField.Date]: FormControl<Date[] | string[]>;
}

@Injectable()
export class InvoiceFormService extends AbstractForm<InvoiceFormField, InvoiceFormModel> {
    readonly #dateAdapter: LocalDateAdapter = inject(LocalDateAdapter);
    /**
     * Date from filter value
     */
    readonly #defaultStartDate: Date = new Date();
    /**
     * Date to filter value
     */
    readonly #defaultEndDate: Date = new Date(
        new Date().setMonth(this.#defaultStartDate.getMonth() + 1),
    );

    public createReactiveForm(): FormGroup<InvoiceFormModel> {
        this.build({
            [InvoiceFormField.Date]: new FormControl<Date[] | string[]>(
                [this.#defaultStartDate, this.#defaultEndDate],
                [Validators.required],
            ),
        });

        return this.form;
    }

    public prepareFormDataBeforeSubmit(prgId: number): AddB2BInvoiceRequest {
        const arOutputDate: Date[] = this.getValueByPath(InvoiceFormField.Date);

        if (Array.isArray(arOutputDate)) {
            const startDate: Date = arOutputDate[0];
            const endDate: Date = arOutputDate[1];

            return {
                dateFrom: this.#dateAdapter.prepareDateForDB(startDate),
                dateTo: this.#dateAdapter.prepareDateForDB(endDate),
                prgId,
            };
        }
    }
}
